<div class="d-flex row">
    <dx-radio-group [items]="PersonActionSelection"
                    [(value)]="actionSelection"
                    (onValueChanged)="onPersonActionChanged()"
                    valueExpr="value"
                    displayExpr="text"></dx-radio-group>
</div>

<div class="d-flex mt-3 row">
    <dx-validation-group #validationGroup>
        @if (actionSelection === PersonAction.Existing) {
            <div class="col">
                <div class="form-group">
                    <adapt-select-person [(person)]="person"
                                         (personChange)="personChange.emit($event)"></adapt-select-person>
                </div>
            </div>
        } @else {
            <div class="col-12 col-md-6 form-group">
                <label>First Name</label>
                <dx-text-box [(value)]="temporaryPerson!.firstName"
                             (onValueChanged)="validateGroup()"
                             placeholder="Enter first name">
                    <dx-validator>
                        <dxi-validator-validation-rule type="required"
                                                       message="First name is required"></dxi-validator-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-12 col-md-6 form-group">
                <label>Surname</label>
                <dx-text-box [(value)]="temporaryPerson!.lastName"
                             (onValueChanged)="validateGroup()"
                             placeholder="Enter surname">
                    <dx-validator>
                        <dxi-validator-validation-rule type="required"
                                                       message="Surname is required"></dxi-validator-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-12 col-md-6 form-group">
                <label>Email</label>
                <dx-text-box mode="email"
                             [(value)]="temporaryPerson!.email"
                             (onValueChanged)="validateGroup()"
                             placeholder="Enter email">
                    <dx-validator>
                        <dxi-validator-validation-rule type="required"
                                                       message="Email is required"></dxi-validator-validation-rule>
                        <dxi-validator-validation-rule type="email"></dxi-validator-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
        }
    </dx-validation-group>
</div>
